import { Box } from '@mui/material';
import styled from 'styled-components';

const StyledBox = styled(Box)`
  .subtitle {
    padding-left: 5px;
    font-size: 10px;
  }

  & > .link-style {
    color: ${(props) => props.theme.palette.primary.main};
    text-decoration: underline;
  }

  .clickable {
    cursor: pointer;
  }
`;

type Props = {
  mainText: string | number;
  subtitle: string | number;
  mainTextClassName?: string;
  subTitleClassName?: string;
  mainTextProps?: Record<string, any>;
  subtitleProps?: Record<string, any>;
};

const TextWithSubtitle = ({
  mainText,
  subtitle,
  mainTextClassName = '',
  subTitleClassName = '',
  mainTextProps,
  subtitleProps,
}: Props) => {
  return (
    <StyledBox>
      <Box className={mainTextClassName} {...mainTextProps} component="span">
        {mainText}
      </Box>
      <Box className={subTitleClassName} {...subtitleProps} component="span" color={'grey'}>
        {subtitle}
      </Box>
    </StyledBox>
  );
};

export default TextWithSubtitle;
